module.exports = __webpack_public_path__ + "static/media/sun-palm.5236c629.svg";